<div class="tw-flex tw-flex-col quill-editor-area "
  [class.no-link]="!enableLink"
  #editorAreaRef
  [class.header-bottom]="headerPosition === 'bottom'">
  <quill-editor
    #editorRef
    [formControl]="editorControl"
    [modules]="quillModules"
    (onEditorCreated)="onEditorCreated($event)"
    (onContentChanged)="onContentChanged($event)"
    class="tw-bg-white tw-w-full tw-rounded-[8px] tw-border tw-border-solid tw-border-mercury-200 tw-border-b-0 {{ editorClass }}"
    id="quill-editor"
    bounds="self"
    [ngClass]="{'quillEditorContainer': !editorClass, 'quillEditorHeight':editorHeight }"
    
  >
  <!-- tw-h-64 sm:tw-h-60 tw-pb-16 sm:tw-pb-[42px] -->
  </quill-editor>

  <div
    class="tw-flex tw-font-medium tw-text-[10px] tw-leading-4 tw-text-mercury-600 tw-pt-1"
    *ngIf="showCharacterLimitText"
    id="character-limit"
    [ngClass]="'tw-justify-' + editorMessagePosition"
  >
    <div class="tw-flex tw-items-center tw-gap-1">
      <div *ngIf="editorMessage"
      class="tw-flex tw-items-center tw-gap-1">
        <i-icon [name]="editorMessageIcon" class="!tw-w-3 !tw-h-3"></i-icon>
        <div>
          {{ editorMessage }}
        </div>
      </div>

      <div>{{ characterCount }}/{{ characterLimit }} Characters</div>
    </div>
  </div>
</div>
